"use client";

// Documented composites/ → app/hooks bridge (see docs/PDP_ARCHITECTURE.md.2).
// Removed when AddToCart is extracted to a cross-framework package.
// eslint-disable-next-line no-restricted-imports
import { useAddToCart as useAppAddToCart } from "@/app/hooks/useAddToCart";

export interface UseAddToCartInput {
	sku: string;
	/** When set, this is the SKU sent to the cart instead of `sku`. */
	variantSku?: string;
	quantity: number;
	/** Defaults to `oneTime`; `monthly` is for subscription products. */
	purchaseType?: "oneTime" | "monthly";
}

export interface UseAddToCartResult {
	cartQuantity: number;
	handleClick: () => Promise<void>;
	loading: boolean;
	/** User-facing message for the failure, bound by the app hook. */
	error: string | null;
	/** Briefly true after a successful add (cleared after 1s by the app hook). */
	submitted: boolean;
}

/**
 * Composites-side wrapper around `app/hooks/useAddToCart`. Translates the
 * composite vocabulary (`sku` + `variantSku` + numeric `quantity`) to the
 * app hook's (`productCode` + string `quantity` + `purchaseType`).
 */
export function useAddToCart(input: UseAddToCartInput): UseAddToCartResult {
	return useAppAddToCart({
		productCode: input.variantSku ?? input.sku,
		quantity: String(input.quantity),
		purchaseType: input.purchaseType ?? "oneTime"
	});
}
